module.exports = __webpack_public_path__ + "src/assets/games/42/109.jpg";